// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.music-player {
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 15px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(255, 105, 180, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.music-player:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.music-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.control-btn {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border: none;
  color: white;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.control-btn:hover {
  background: linear-gradient(45deg, #ff1493, #dc143c);
  transform: scale(1.1);
}

.volume-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.volume-slider {
  width: 60px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.3);
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
}

.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(255, 105, 180, 0.5);
}

.volume-slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 6px rgba(255, 105, 180, 0.5);
}

.music-info {
  font-size: 12px;
  color: white;
  text-align: center;
  font-weight: 500;
}

.music-title {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .music-player {
    top: 10px;
    right: 10px;
    padding: 10px;
  }
  
  .music-controls {
    gap: 8px;
  }
  
  .control-btn {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  
  .volume-slider {
    width: 50px;
  }
  
  .music-info {
    font-size: 10px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/MusicPlayer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE;IACE,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".music-player {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 15px;\n  z-index: 1000;\n  box-shadow: 0 4px 20px rgba(255, 105, 180, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.music-player:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.music-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.control-btn {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border: none;\n  color: white;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.control-btn:hover {\n  background: linear-gradient(45deg, #ff1493, #dc143c);\n  transform: scale(1.1);\n}\n\n.volume-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.volume-slider {\n  width: 60px;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.3);\n  outline: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n}\n\n.volume-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(255, 105, 180, 0.5);\n}\n\n.volume-slider::-moz-range-thumb {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 6px rgba(255, 105, 180, 0.5);\n}\n\n.music-info {\n  font-size: 12px;\n  color: white;\n  text-align: center;\n  font-weight: 500;\n}\n\n.music-title {\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .music-player {\n    top: 10px;\n    right: 10px;\n    padding: 10px;\n  }\n  \n  .music-controls {\n    gap: 8px;\n  }\n  \n  .control-btn {\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n  }\n  \n  .volume-slider {\n    width: 50px;\n  }\n  \n  .music-info {\n    font-size: 10px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
